import React, { useEffect } from 'react';

const ServicePlansTemplateWidget = ({ selectedLayout,isTemplateId,widgetId,pricingTableTabData }) => {

    // Call Css
    useEffect(() => {
        // Remove other module CSS
        const oldLinks = document.querySelectorAll('link[data-dynamic-css]');
        oldLinks.forEach(link => link.remove());

        // Load CSS
        const link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = `${process.env.PUBLIC_URL}/pricing-table/temp-css/PricingTableWidget.css`;
        if (widgetId) {
            link.setAttribute("pricing-table-data-dynamic-css", "pricing-table");
        } else {
            link.setAttribute("data-dynamic-css", "pricing-table");
        }
        document.head.appendChild(link);

        // Clean up on unmount
        return () => {
            const thisLink = document.querySelector('link[data-dynamic-css="pricing-table"]');
            if (thisLink) thisLink.remove();
        };
    }, [widgetId]);

    return (
        <>
            <div className={`upgadeify pricing-table-service-plans-temp ${pricingTableTabData.is_website_frontend}`}>
            <div className='pricing_table_grid'>
                    <div className="panel pricing-table">
                        <div className="pricing-plan">
                            <h2 className="pricing-header" style={{ color: "#000" }}>FREE</h2>
                            <span className="pricing-price" style={{ color: "#000", fontSize:"32px" }}>$0 </span>
                            <span className="pricing-price" style={{ color: "#111", fontSize:"12px" }}></span>
                            <a href="#/" className="pricing-button">TRY FREE</a>
                            <span className="pricing-price" style={{ color: "#111", fontSize:"12px" }}>No credit card required</span>
                            <ul className="pricing-features">
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>1</strong> User</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>5 GB</strong> secure storage</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>Knowledge base</strong> support</li>
                            </ul>
                        </div>
                        <div className="pricing-plan">
                            <h2 className="pricing-header" style={{ color: "#000" }}>STARTUP</h2>
                            <span className="pricing-price" style={{ color: "#000", fontSize:"32px" }}>$7 </span>
                            <span className="pricing-price" style={{ color: "#111", fontSize:"12px" }}>per user/month billed annually</span>
                            <a href="#/" className="pricing-button service_button">GET STARTED</a>
                            <span className="pricing-price" style={{ color: "#111", fontSize:"12px" }}>No credit card required</span>
                            <ul className="pricing-features">
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>5</strong> User</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>20 GB</strong> secure storage</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>Email </strong> support</li>
                            </ul>
                        </div>
                        <div className="pricing-plan business-plan">
                            <div className="pricing-plan-label">BEST VALUE</div>
                            <h2 className="pricing-header" style={{ color: "#000" }}>BUSINESS</h2>
                            <span className="pricing-price" style={{ color: "#000", fontSize:"32px" }}>$15 </span>
                            <span className="pricing-price" style={{ color: "#111", fontSize:"12px" }}>per user/month billed annually</span>
                            <a href="#/" className="pricing-button service_button">GET STARTED</a>
                            <span className="pricing-price" style={{ color: "#111", fontSize:"12px" }}>No credit card required</span>
                            <ul className="pricing-features">
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>Unlimited </strong> User</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>100 GB</strong> secure storage</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>Business hours phone </strong> support</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>Analytics </strong></li>
                            </ul>
                        </div>
                        <div className="pricing-plan">
                            <h2 className="pricing-header" style={{ color: "#000" }}>ENTERPRISE</h2>
                            <span className="pricing-price" style={{ color: "#000", fontSize:"32px" }}>$50 </span>
                            <span className="pricing-price" style={{ color: "#111", fontSize:"12px" }}>per user/month billed annually</span>
                            <a href="#/" className="pricing-button service_button">CONTACT US</a>
                            <span className="pricing-price" style={{ color: "#111", fontSize:"12px" }}>No credit card required</span>
                            <ul className="pricing-features">
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>Unlimited </strong> User</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>Unlimited</strong> secure storage</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>24/7 phone </strong> support</li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>Analytics </strong></li>
                                <li className="pricing-features-item" style={{ color: "#4a4a4a", fontSize:"14px" }}><strong>Analytics </strong> branding</li>
                            </ul>
                        </div>
                       

                    </div>
                </div>
            </div>
        </>
    );
};

export default ServicePlansTemplateWidget;
